import React from 'react';
import { useSelector } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import Activity from './Buttons/Activity';
import Notifications from './Buttons/Notifications';
import Mail from './Buttons/Mail';
import BarcodeScanner from './Buttons/BarcodeScanner';

export default function Bottom(props) {
    // fabButton: {
    //     position: 'absolute',
    //     zIndex: 1,
    //     top: -30,
    //     left: 0,
    //     right: 0,
    //     margin: '0 auto',
    // },

    const { clicked } = props;
    const isInternalAdmin = useSelector(state => state.auth.isInternalAdmin);
    const location = 'bottom';
    const bottomBar = (
        <AppBar variant='mobileAppBar' sx={{ display: { xs: 'block', md: 'none' }}}>
            <Toolbar>
                <IconButton edge="start" aria-label="open drawer" onClick={clicked} sx={{ color: '#FFF', marginRight: 'auto' }}>
                    <MenuIcon />
                </IconButton>
                {!isInternalAdmin && <BarcodeScanner />}
                {/* <Activity location={location} /> */}
                {!isInternalAdmin && <Mail location={location} />}
                {!isInternalAdmin && <Notifications location={location} />}
            </Toolbar>
        </AppBar>
    );

    return bottomBar;
}